import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LogoProps {
    tone?: 'default' | 'inverted'
    className?: string
}

export const Logo: FC<LogoProps> = ({ tone = 'default', className }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            <svg viewBox='0 0 32 32' className='size-8 shrink-0' aria-hidden='true'>
                <rect width='32' height='32' rx='9' className='fill-primary' />
                <path
                    d='M9.5 10.5 15 16l-5.5 5.5'
                    fill='none'
                    strokeWidth='2.8'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    className='stroke-primary-foreground'
                />
                <rect x='16.5' y='19.6' width='7.5' height='2.8' rx='1.4' className='fill-accent' />
            </svg>

            <span className='flex flex-col leading-none'>
                <span className='font-heading text-[17px] font-bold tracking-tight'>
                    ByteWise
                </span>

                <span className={cn('mt-1 font-mono text-[10px] tracking-[0.2em] uppercase', tone === 'inverted' ? 'text-background/60' : 'text-muted-foreground')}>
                    Academy
                </span>
            </span>
        </span>
    )
}
